import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const ReviewCoveragePlan = lazy(
  () => import('@pages/landing/ReviewCoveragePlan'),
);

export const ReviewCoveragePlanRoutes: RouteObject[] = [
  {
    path: '/review-coverage-plan',
    element: (
      <React.Suspense>
        <ReviewCoveragePlan />
      </React.Suspense>
    ),
  },
];
